export default {
  path: '/main/helper/aiAssistantStatistics',
  name: 'AiAssistantStatistics',
  component: () =>
    import(
      '@/views/main/helper/aiAssistantStatistics/AiAssistantStatistics.vue'
    )
}
